import { Button, Card, Typography, notification } from 'antd';
import React, { useState } from 'react';
import { ComponentType } from '../../../types/course';
import { useIssueCommandMutation } from '../../../features/courses/coursesApi';
import { SaveOutlined } from '@ant-design/icons';
import { Enums } from '../../../shared';
import { useTranslation } from 'react-i18next';

const { Paragraph } = Typography;

const ComponentDescription = ({ component }: { component: ComponentType }) => {
    const { t } = useTranslation();
    const [description, setDescription] = useState(component.description);
    const [issueCommand, {}] = useIssueCommandMutation();

    const updateDescriptionButton = (component) => (
        <Button
            key={'update-description-button'}
            icon={<SaveOutlined />}
            onClick={() => {
                issueCommand({
                    command: {
                        type: Enums.COMMAND_TYPES.COMPONENT_UPDATE,
                        componentId: component.id,
                        description: description,
                    },
                })
                    .unwrap()
                    .then((response) => {
                        notification.info({
                            message: t('workbench.lessons.notifications.descriptionUpdated'),
                            duration: 2,
                        });
                    })
                    .catch((err) => {
                        notification.error({
                            message: t('workbench.lessons.notifications.sww'),
                            duration: 2,
                        });
                    });
            }}
        >
            {t('update')}
        </Button>
    );

    return (
        <Card
            title={t('workbench.lessons.update.description')}
            extra={[updateDescriptionButton(component)]}
        >
            <Paragraph
                editable={{
                    onChange: setDescription,
                    autoSize: { maxRows: 10, minRows: 5 },
                }}
            >
                {description}
            </Paragraph>
        </Card>
    );
};

export default ComponentDescription;
